export const DealersInsightsLevelActionTypes = {
  SET_LEVEL: '[DealersInsights Level] SET LEVEL',
  SET_INITIAL_LEVEL: '[DealersInsights Level] SET INITIAL LEVEL',
  SET_DEALER_ID: '[DealersInsights Level] SET DEALER ID',
  MANUALLY_SET_DEALER_ID: '[DealersInsights Level] MANUALLY SET DEALER ID',
  RESET_STATE: '[DealersInsights Level] RESET STATE',
  TOGGLE_DEALER_MENU: '[DealersInsights Level] TOGGLE DEALER MENU',
};

export const DEALERS_INSIGHTS_LEVELS = {
  NETWORK: 'network',
  DEALER: 'dealer',
};

export const DEALERS_INSIGHTS_INVALID_LEVEL_ERROR_MESSAGE = `dealer insights current level must be one of ${Object.values(
  DEALERS_INSIGHTS_LEVELS,
)}`;
